/* eslint-disable no-unused-vars */
import React from "react";
/**@Css */
import "./App.css";
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { BrowserRouter as Router, Routes, Route, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { VenueProvider } from "./context/VenueContext";
import { HotelProvider } from "./context/HotelContext";
import { PrimeReactProvider } from 'primereact/api';
import router from "./router";

const queryClient = new QueryClient();

const App = () => {
  const value = {
        appendTo: 'self',
    };
  return (
    <div className="App">

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <PrimeReactProvider context={value}>
        <QueryClientProvider client={queryClient}>
          <VenueProvider>
            <HotelProvider>
              <RouterProvider router={router} />
            </HotelProvider>
          </VenueProvider>
        </QueryClientProvider>
      </PrimeReactProvider>
    </div>
  );
};

export default App;
